import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthContext } from "@/context/useAuthContext";
import { Loading } from "@/layouts/components";
import { GameTimeFrame, GameUserStatus, useGetPlaceFavoritesQuery, useGetUserGamesQuery, } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { GameList } from "./components/GameList";
import { Places } from "./components/Places";
// import { Upcoming } from './components/Upcoming';
export var HomePage = function () {
    var _a, _b, _c, _d;
    var user = useAuthContext().user;
    var gameListGetState = useGetUserGamesQuery({
        id: user.id,
        timeframe: GameTimeFrame.Upcoming,
        memberStatuses: [GameUserStatus.Allowed, GameUserStatus.Confirmed],
        limit: 3,
    });
    var placeFavoritesGetState = useGetPlaceFavoritesQuery({});
    var gameInvitedListGetState = useGetUserGamesQuery({
        id: user.id,
        timeframe: GameTimeFrame.Upcoming,
        memberStatuses: [GameUserStatus.Invited],
        limit: 3,
    });
    var gameRequestListGetState = useGetUserGamesQuery({
        id: user.id,
        timeframe: GameTimeFrame.Upcoming,
        memberStatuses: [GameUserStatus.Requested, GameUserStatus.Declined],
        limit: 3,
    });
    useSetPageData({ title: "Старт" });
    var isLoading = gameListGetState.isLoading ||
        gameInvitedListGetState.isLoading ||
        gameRequestListGetState.isLoading ||
        placeFavoritesGetState.isLoading;
    return (_jsxs("div", { children: [_jsx(GameList, { header: "\u041C\u043E\u0438 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0438\u0433\u0440\u044B", list: ((_a = gameListGetState.data) === null || _a === void 0 ? void 0 : _a.items) || [] }), _jsx(GameList, { header: "\u041C\u0435\u043D\u044F \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u043B\u0438", list: ((_b = gameInvitedListGetState.data) === null || _b === void 0 ? void 0 : _b.items) || [] }), _jsx(GameList, { header: "\u041C\u043E\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u044B", list: ((_c = gameRequestListGetState.data) === null || _c === void 0 ? void 0 : _c.items) || [] }), _jsx(Places, { places: ((_d = placeFavoritesGetState.data) === null || _d === void 0 ? void 0 : _d.items) || [] }), _jsx(Loading, { isActive: isLoading, loadingKey: "homePage" })] }));
};
